import { createElement as _createElement } from "react";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Autocomplete as MuiAutocomplete, Chip, CircularProgress, TextField, } from "@mui/material";
import { identity, merge } from "lodash-es";
import React from "react";
export const AutocompleteMultiple = ({ value = [], onChange, placeholder, inputLabel, autoFocus, required, error, loading, TextFieldProps, filterOptions, renderValue, ...props }) => {
    const handleChange = React.useCallback((event, value, reason, details) => {
        onChange(value, event, reason, details);
    }, [onChange]);
    const handleReset = React.useCallback((event) => {
        onChange([], event);
    }, [onChange]);
    return (_jsx(MuiAutocomplete, { ...props, multiple: true, openOnFocus: true, disableCloseOnSelect: true, getOptionKey: props.getOptionKey, renderInput: params => {
            return (_jsx(TextField, { ...merge(params, TextFieldProps), placeholder: placeholder, label: inputLabel, autoFocus: autoFocus, required: required, error: Boolean(error), helperText: error, slotProps: {
                    input: {
                        ...params.InputProps,
                        endAdornment: (_jsxs(_Fragment, { children: [loading ? (_jsx(CircularProgress, { color: "inherit", size: 20 })) : null, params.InputProps.endAdornment] })),
                    },
                } }));
        }, renderValue: renderValue ??
            ((value, getTagProps) => value.map((value, index) => {
                const label = props?.getOptionLabel?.(value) ??
                    (typeof value === "string" ? value : "");
                return (_createElement(Chip, { variant: "outlined", size: "small", label: label, ...getTagProps({ index }), key: `chip-${index}-${label}` }));
            })), value: value, onChange: handleChange, onReset: handleReset, filterOptions: filterOptions ?? identity, loading: loading }));
};
//# sourceMappingURL=AutocompleteMultiple.js.map